import { render, staticRenderFns } from "./ShippingCostDetail.vue?vue&type=template&id=eb0066f8&scoped=true"
import script from "./ShippingCostDetail.vue?vue&type=script&lang=js"
export * from "./ShippingCostDetail.vue?vue&type=script&lang=js"
import style0 from "./ShippingCostDetail.vue?vue&type=style&index=0&id=eb0066f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb0066f8",
  null
  
)

export default component.exports